import Component from './Component'

export default class File extends Component {

	static _type = 'File'

	form			// Parent form component

	input_el		// DOM Elements
	feedback_el

	tether () {
		super.tether()

		// Own DOM elements
		this.input_el = this.base.querySelector('input')
		this.label_el = this.base.querySelector('label.custom-file-label')
		this.feedback_el = this.base.querySelector('.invalid-feedback')

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil
		//this.form.registerInput(this.params.name, this)

		// Create bound event handlers and register them
		this.changeListener = File._changeListener.bind(this)
		this.updateListener = File._updateListener.bind(this)
		$(this.input_el).on('change', this.changeListener)								// jQuery event
		this.form.data.record.on(this.params.name + '-updated', this.updateListener)	// node event

		if ('init' in this.params && typeof this.params.init == 'function') {
			this.params.init(this)
		}
	}

	static _changeListener () {

		let f_list = this.input_el.files

		// Update display label
		$(this.label_el).text((f_list.length == 1) ? f_list[0].name : (f_list.length > 1) ? f_list.length + ' fájl kiválasztva' : 'Válassza ki a fájlt')

		// Send FileList to the record as value
		this.form.data[this.params.name] = f_list
	}

	static _updateListener (value, errors) {

		// File input values should not be programmatically changed

		// Render validation
		this.renderValidation(errors)

		// Update hook
		if ('update' in this.params && typeof this.params.update == 'function') {
			this.params.update(value, this.params.name, this.form.data, this.params)
		}
	}

	renderValidation (errors) {
		if (errors == null) {
			// Validation successful
			if (('prepend' in this.params || 'append' in this.params)) {
				$(this.base).find('.input-group').removeClass('is-invalid')
			}
			$(this.input_el).removeClass('is-invalid')
			$(this.input_el).parent().removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			if (('prepend' in this.params || 'append' in this.params)) {
				$(this.base).find('.input-group').addClass('is-invalid')
			}
			$(this.input_el).addClass('is-invalid')
			$(this.input_el).parent().addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		$(this.input_el).off('change', this.changeListener)
		this.form.data.record.off(this.params.name + '-updated', this.updateListener)

		delete this.input_el
		delete this.label_el
		delete this.feedback_el
		delete this.form

		super.destroy()
	}
}
